import { put, takeEvery, call } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../api';
import api from '../../api/endpoints';

function* tokenAuth({ payload: { values, onSuccess } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.token_auth,
      data: values
    });

    onSuccess && onSuccess(data.result);
    yield put(actions.tokenAuthDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.tokenAuthFailed,
      endpoint: api.token_auth.url
    });
  }
}

export const tokenAuthSaga = takeEvery(types.TOKEN_AUTH_REQUEST, tokenAuth);